import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { HomeAwayListingDetailsDialogComponent } from './homeaway-listing-details-dialog.component'

@Injectable()
export class HomeAwayListingDetailsDialogService {
  constructor(private dialog: DialogService) {}

  open(rentalId: string) {
    const config: MatDialogConfig = {
      data: { rentalId },
      width: '700px',
      height: 'auto',
    }
    return this.dialog.openVariableDialog(HomeAwayListingDetailsDialogComponent, config)
  }
}
